export enum errorCode {
  badRequest = 400,
  notAuthenticated = 401,
  notPermitted = 403,
  notExist = 404,
  validationError = 422,
  serverError = 500,
  conflictError = 409,
}
